// extracted by mini-css-extract-plugin
export default {"root":"ChatPinTitle_root__4OeqA"};